import { render, staticRenderFns } from "./EditAdminAccountModal.vue?vue&type=template&id=756b8dde&scoped=true"
import script from "./EditAdminAccountModal.vue?vue&type=script&lang=ts"
export * from "./EditAdminAccountModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756b8dde",
  null
  
)

export default component.exports